
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import TooltipButton from '../TooltipButton.vue';

@Component({
  inheritAttrs: false,
  components: { TooltipButton }
})
export default class CloseBtn extends Vue {
  @Prop({ type: String, default: 'labels.generic.close' })
  toolTipLabel!: string;

  @Prop({ type: String, default: '0.4rem' })
  top!: string;

  @Prop({ type: String, default: '0.4rem' })
  right!: string;

  @Prop({ type: String, default: '' })
  color!: string;

  get commonAttrs() {
    return {
      icon: true,
      absolute: true,
      light: false
    };
  }
}
